const JOBS = [
  {
    id: "shed",
    title: "Shed Power Washing",
    before: { src: "/before_wash.jpg", alt: "Shed before power washing — dark weathered wood" },
    after: { src: "/after_wash.jpg", alt: "Shed after power washing — bright clean wood" },
  },
  {
    id: "fence",
    title: "Fence Power Washing",
    before: { src: "/fence_after.webp", alt: "Fence before power washing" },
    after: { src: "/fence_before.webp", alt: "Fence after power washing" },
  },
];

export default function BeforeAfter() {
  return (
    <section data-testid="before-after-section" id="results" className="py-24 sm:py-32 px-6 lg:px-8 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B] mb-4">Real Work. Real Results.</p>
        <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl mb-4">Before &amp; After</h2>
        <p className="text-neutral-400 max-w-2xl mb-14">Recent power washing jobs — years of grime gone in one visit. This is what we do.</p>
        <div className="space-y-14">
          {JOBS.map((job) => (
            <div key={job.id} data-testid={`before-after-${job.id}`}>
              <h3 className="font-display uppercase tracking-wide text-2xl mb-4 text-neutral-200">{job.title}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <figure data-testid={`before-photo-${job.id}`} className="relative border border-white/10 overflow-hidden group">
                  <img src={job.before.src} alt={job.before.alt} className="w-full h-[420px] object-cover transition-transform duration-500 group-hover:scale-105" />
                  <figcaption className="absolute top-4 left-4 bg-black/70 backdrop-blur px-4 py-2 font-display uppercase tracking-wider text-xl border border-white/20">
                    Before
                  </figcaption>
                </figure>
                <figure data-testid={`after-photo-${job.id}`} className="relative border border-[#F59E0B]/50 overflow-hidden group">
                  <img src={job.after.src} alt={job.after.alt} className="w-full h-[420px] object-cover transition-transform duration-500 group-hover:scale-105" />
                  <figcaption className="absolute top-4 left-4 bg-[#F59E0B] text-black px-4 py-2 font-display uppercase tracking-wider text-xl">
                    After
                  </figcaption>
                </figure>
              </div>
            </div>
          ))}
        </div>
        <div data-testid="work-video-block" className="mt-14 max-w-3xl mx-auto">
          <h3 className="font-display uppercase tracking-wide text-2xl mb-4 text-neutral-200 text-center">Watch Us Work</h3>
          <video
            data-testid="work-video"
            src="/work_video.mp4"
            controls
            playsInline
            preload="metadata"
            className="w-full border border-white/10"
          />
        </div>
        <div className="mt-10 text-center">
          <a
            data-testid="before-after-quote-button"
            href="#quote"
            className="inline-flex items-center gap-2 bg-[#F59E0B] text-black font-display uppercase tracking-wider text-2xl px-8 py-4 hover:bg-[#D97706] transition-colors duration-200 active:scale-95"
          >
            Get Results Like This
          </a>
        </div>
      </div>
    </section>
  );
}
